import { render, staticRenderFns } from "./WorkFileCreation.vue?vue&type=template&id=4dced999"
import script from "./WorkFileCreation.vue?vue&type=script&lang=ts"
export * from "./WorkFileCreation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports